import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IEmail } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

export async function UpdateEmail(objData: IEmail) {
  const url = `${endpoints.USERFHIR}/email-update`;
  const data = auxiliarData.Email(objData);
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: await useAuth.getUserToken(),
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`UpdateEmail error: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("UpdateEmail ", error);
      // toast.error(`UpdateEmail Error: ${error?.response?.status}`);
      throw new Error();
    });

  if (response) return response;
}
